import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const productCategoryModule = {
  namespaced: true,
  state: {
    productCategorys: null,
    productCategory: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default productCategoryModule;
